import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import { cn } from '../../../utils/cn';
import { useCompany } from '../../../components/context/CompanyContext';

const AppointmentPoliciesCard = () => {
  const [expandedSection, setExpandedSection] = useState(null);
  const { company } = useCompany();

  const policies = [
    {
      id: 'cancellation',
      title: 'Cancellation Policy',
      icon: 'XCircle',
      content: company?.clientProtocols?.cancellationPolicy || 'Please provide at least 24 hours notice for cancellations. Late cancellations or no-shows may be subject to a cancellation fee.'
    },
    {
      id: 'arrival',
      title: 'Arrival Time',
      icon: 'Clock',
      content: company?.clientProtocols?.arrivalPolicy || 'Please arrive 10 minutes early to complete any necessary paperwork and ensure your appointment starts on time.'
    },
    {
      id: 'preparation',
      title: 'Preparation Instructions',
      icon: 'Sparkles',
      content: company?.clientProtocols?.preparationInstructions || 'Remove any existing nail polish before your appointment. Avoid using hand lotion on the day of your service for best results.'
    },
    {
      id: 'payment',
      title: 'Payment Methods',
      icon: 'CreditCard',
      content: company?.clientProtocols?.acceptedPaymentMethods ? `We accept ${company?.clientProtocols?.acceptedPaymentMethods}. Gratuity is appreciated but not required.` : 'We accept cash, credit cards, and digital payments. Gratuity is appreciated but not required.'
    }
  ];

  const toggleSection = (id) => {
    setExpandedSection(expandedSection === id ? null : id);
  };

  return (
    <div className="bg-card rounded-xl p-6 md:p-8 border border-border shadow-sm animate-fade-in">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-12 h-12 bg-gradient-to-br from-primary to-secondary rounded-lg flex items-center justify-center">
          <Icon name="FileText" size={24} color="white" />
        </div>
        <h2 className="font-heading font-semibold text-2xl text-foreground">
          Important Information
        </h2>
      </div>

      <div className="space-y-3">
        {policies?.map((policy) => (
          <div
            key={policy?.id}
            className="border border-border rounded-lg overflow-hidden transition-all duration-250"
          >
            <button
              onClick={() => toggleSection(policy?.id)}
              className="w-full flex items-center justify-between gap-3 p-4 bg-muted/30 hover:bg-muted/50 transition-colors duration-250"
            >
              <div className="flex items-center gap-3">
                <Icon name={policy?.icon} size={20} className="text-primary flex-shrink-0" />
                <span className="font-caption font-semibold text-base text-foreground text-left">
                  {policy?.title}
                </span>
              </div>
              <Icon
                name="ChevronDown"
                size={20}
                className={cn(
                  "text-muted-foreground transition-transform duration-250 flex-shrink-0",
                  expandedSection === policy?.id && "rotate-180"
                )}
              />
            </button>
            
            <div
              className={cn(
                "overflow-hidden transition-all duration-250 ease-elegant",
                expandedSection === policy?.id ? "max-h-40" : "max-h-0"
              )}
            >
              <div className="p-4 bg-card">
                <p className="text-sm text-muted-foreground font-caption leading-relaxed">
                  {policy?.content}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AppointmentPoliciesCard;